import type { IApplicationDetails } from '@/features/ApplicationForm/types';
import OwnershipInformation from './OwnershipInformation';
import PropertyDetails from './PropertyDetails';
import PropertyManagement from './PropertyManagement';

export const ApplicationDetails = ({ applicationData, files }: IApplicationDetails) => {
  return (
    <>
      <PropertyDetails propertyDetails={applicationData.propertyDetails} files={files} />
      <OwnershipInformation data={applicationData.ownershipInformation} files={[]} />
      <PropertyManagement data={applicationData.propertyManagement} files={[]} />
    </>
  );
};
